export type SearchTabDepartmentType = "pediatrician" | "obstetrician" | "midwife";
export type SortRule = "score" | "time_desc" | "time_asc";

type NumberOption = { text: string; value: number };
type StringOption<T extends string> = { text: string; value: T };

export interface SearchTabOptions {
  departmentType: Array<StringOption<SearchTabDepartmentType>>;
  userInterest: NumberOption[];
  childSex: NumberOption[];
  userAgeRank: NumberOption[];
  inPregnancy: Array<StringOption<"pregnant" | "postpartum" | "teens" | "others">>;
  weeksOfPregnancyRank: NumberOption[];
  monthsOfPostpartumRank: NumberOption[];
  answerKeywordScopes: Array<StringOption<"answer" | "question" | "complaint">>;
  sortRules: Array<StringOption<SortRule>>;
}

export interface SearchTabQuery {
  departmentType: SearchTabDepartmentType | null;
  childAgeRange: { gte: number | null; lte: number | null };
  childSex: number[];
  inPregnancy: string[];
  userAgeRank: number[];
  weeksOfPregnancyRank: number[];
  monthsOfPostpartumRank: number[];
  userInterest: number[];
  icd10Keyword: string;
  answerKeywords: string;
  answerKeywordScopes: string[];
  doctorFamilyName: string;
  doctorFirstName: string;
  doctorId: number | null;
  displayScore: boolean;
  sortRules: SortRule;
}

export const SEARCH_TAB_OPTIONS: SearchTabOptions = {
  departmentType: [
    { text: "小児科", value: "pediatrician" },
    { text: "産婦人科", value: "obstetrician" },
    { text: "助産師", value: "midwife" }
  ],
  userInterest: [
    { text: "家でのケアの方法", value: 1 },
    { text: "病院受診の目安", value: 2 },
    { text: "原因", value: 3 },
    { text: "薬の使い方", value: 4 },
    { text: "その他", value: 5 }
  ],
  childSex: [
    { text: "男の子", value: 0 },
    { text: "女の子", value: 1 }
  ],
  userAgeRank: [
    { text: "-14歳", value: 1 },
    { text: "15-19歳", value: 2 },
    { text: "20-24歳", value: 3 },
    { text: "25-29歳", value: 4 },
    { text: "30-34歳", value: 5 },
    { text: "35-39歳", value: 6 },
    { text: "40-44歳", value: 7 },
    { text: "45-49歳", value: 8 },
    { text: "50-54歳", value: 9 },
    { text: "55-59歳", value: 10 },
    { text: "60歳-", value: 11 }
  ],
  inPregnancy: [
    { text: "妊娠中", value: "pregnant" },
    { text: "産後", value: "postpartum" },
    { text: "小中高生", value: "teens" },
    { text: "その他", value: "others" }
  ],
  weeksOfPregnancyRank: [
    { text: "-14週", value: 1 },
    { text: "15-21週", value: 2 },
    { text: "22-27週", value: 3 },
    { text: "28-33週", value: 4 },
    { text: "34-36週", value: 5 },
    { text: "37週-", value: 6 }
  ],
  monthsOfPostpartumRank: [
    { text: "1ヶ月未満", value: 1 },
    { text: "1-3ヶ月", value: 2 },
    { text: "4-6ヶ月", value: 3 },
    { text: "7-11ヶ月", value: 4 },
    { text: "12-17ヶ月", value: 5 },
    { text: "18-23ヶ月", value: 6 },
    { text: "24ヶ月-", value: 7 }
  ],
  answerKeywordScopes: [
    { text: "回答文", value: "answer" },
    { text: "質問文", value: "question" },
    { text: "主訴", value: "complaint" }
  ],
  sortRules: [
    { text: "関連度順", value: "score" },
    { text: "新しい順", value: "time_desc" },
    { text: "古い順", value: "time_asc" }
  ]
};

export function createDefaultSearchTabQuery(): SearchTabQuery {
  return {
    departmentType: null,
    childAgeRange: {
      gte: null,
      lte: null
    },
    childSex: [],
    inPregnancy: [],
    userAgeRank: [],
    weeksOfPregnancyRank: [],
    monthsOfPostpartumRank: [],
    userInterest: [],
    icd10Keyword: "",
    answerKeywords: "",
    answerKeywordScopes: ["answer"],
    doctorFamilyName: "",
    doctorFirstName: "",
    doctorId: null,
    displayScore: false,
    sortRules: "score"
  };
}
